import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <>
      <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.95522 15.2239H7.8209C8.34866 15.2239 8.77612 15.6513 8.77612 16.1791V19.0448C8.77612 19.5725 8.34866 20 7.8209 20H4.95522C4.42746 20 4 19.5725 4 19.0448V16.1791C4 15.6513 4.42746 15.2239 4.95522 15.2239Z"
          stroke="#818C99"
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.9921 4.25648L19.7435 6.00788C20.0855 6.34985 20.0855 6.90436 19.7435 7.24633L17.9921 8.99773C17.6502 9.3397 17.0961 9.3397 16.7541 8.99773L15.0027 7.24633C14.6608 6.90436 14.6608 6.34985 15.0027 6.00788L16.7541 4.25648C17.0961 3.91451 17.6502 3.91451 17.9921 4.25648Z"
          stroke="#818C99"
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.38806 9.01493C7.70695 9.01493 8.77612 7.94576 8.77612 6.62687C8.77612 5.30798 7.70695 4.23881 6.38806 4.23881C5.06917 4.23881 4 5.30798 4 6.62687C4 7.94576 5.06917 9.01493 6.38806 9.01493Z"
          stroke="#818C99"
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.3731 20C18.692 20 19.7612 18.9308 19.7612 17.6119C19.7612 16.2931 18.692 15.2239 17.3731 15.2239C16.0542 15.2239 14.9851 16.2931 14.9851 17.6119C14.9851 18.9308 16.0542 20 17.3731 20Z"
          stroke="#818C99"
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.38806 12.8358V11.403"
          stroke="#818C99"
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.1642 6.62687H12.597"
          stroke="#818C99"
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.3731 12.8358V11.403"
          stroke="#818C99"
          strokeWidth="1.2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
